import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

import Vue from "vue";
// action types

export const PAGINATE_ALL_TICKETS = "getPaginatedTickets";
export const PAGINATE_ALL_MY_TICKETS = "getPaginatedMyTickets";
export const ALL_TICKETS = "getAllTickets";
export const CREATE_TICKET_FORM = "createTicketForm";
export const DELETE_TICKET = "deleteTicket";
export const GET_TICKET_DATA = "getTicketData";
export const CREATE_TICKET = "createTicket";
export const UPDATE_TICKET = "updateTicket";
export const GET_TICKETS_REPORT = "getTicketsReport";
export const APPROVE_TICKET = "approveTicket";


// mutation types

export const SET_PAGINATED_TICKETS = "setPaginatedTickets";
export const SET_PAGINATED_MY_TICKETS = "setPaginatedMyTickets";

export const SET_ALL_TICKETS = "setAllTickets";
export const SET_TICKET_DATA = "setTicketData";
export const SET_TICKET_META = "setTicketMeta";
export const SET_TICKET_ERROR = "setTicketError";
export const SET_TICKET_LOADING = "setTicketLoading";
export const CLEAR_TICKET_ERROR = "clearTicketError";
export const SET_IS_DISABLED_TICKET = "setIsDisabledTicket";


const state = {
    tickets: [],
    paginatedTickets: [],
    paginatedMyTickets: [],
    ticket_data: {},
    meta_ticket : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllTickets(state) {
        return state.paginatedTickets;
    },

    paginateAllMyTickets(state) {
        return state.paginatedMyTickets;
    },

    allTickets(state) {
        return state.tickets;
    },

    getTicketData(state) {
        return state.ticket_data;
    },

    meta_ticket(state) {
        return state.meta_ticket;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_TICKETS](context, payload) {
        context.commit(SET_IS_DISABLED_TICKET, false);
        context.commit(SET_TICKET_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/tickets?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_TICKET_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_TICKETS, data);
                context.commit(SET_TICKET_META, data);
                context.commit(SET_TICKET_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_TICKET_LOADING, false);
            context.commit(SET_TICKET_ERROR, response.errors);
        });
        ;
        
    },

    [PAGINATE_ALL_MY_TICKETS](context, payload) {
        context.commit(SET_IS_DISABLED_TICKET, false);
        context.commit(SET_TICKET_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        Vue.axios.get(`/my_tickets?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_TICKET_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_MY_TICKETS, data);
                context.commit(SET_TICKET_META, data);
                context.commit(SET_TICKET_LOADING, false);
            }
            
        })
        .catch((error) => {
            if (error.response) {
                if (error.response.status === 402) {
                    context.commit(SET_TICKET_LOADING, false);
                    if(error.response.data.error === 'Insufficient balance') {
                        router.push({ name: 'credit_balance' });
                    }

                    if(error.response.data.error === 'Member status error') {
                        router.push({ name: 'status_error' });
                    }

                    if(error.response.data.error === 'No photo found') {
                        router.push({ name: 'no_photo' });
                    }
                     
                } else {
                    context.commit(SET_TICKET_LOADING, false);
                    context.commit(SET_TICKET_ERROR, error.response.data.errors);
                }
            } else {
                // Handle cases where error.response is undefined (network error, etc.)
                context.commit(SET_TICKET_LOADING, false);
            }
        });
        
    },

    [ALL_TICKETS]() {
        return new Promise(resolve => {
            ApiService.get('/ticketsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_TICKET_FORM](context) {
        context.commit(SET_TICKET_LOADING, false);
        context.commit(SET_TICKET_ERROR, false);
        context.commit(SET_IS_DISABLED_TICKET, false);
    },

    [GET_TICKET_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_TICKET, true);
        context.commit(SET_TICKET_LOADING, true);
        context.commit(CLEAR_TICKET_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/ticket/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_TICKET_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_TICKET_DATA, response.data);
                    context.commit(SET_TICKET_LOADING, false);
                    context.commit(SET_IS_DISABLED_TICKET, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_TICKET_LOADING, false);
                context.commit(SET_TICKET_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_TICKET, true);
            });
        });
    },

    [CREATE_TICKET](context, payload) {
        context.commit(SET_TICKET_LOADING, false);
        context.commit(SET_IS_DISABLED_TICKET, true);
        context.commit(CLEAR_TICKET_ERROR);
        return ApiService.post("/ticket/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_TICKET_ERROR);
            }
            else{
                context.commit(SET_TICKET_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Bilet başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_TICKET_ERROR);
                context.commit(SET_IS_DISABLED_TICKET, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_TICKET_LOADING, false);
            context.commit(SET_TICKET_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_TICKET, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_TICKET](context, payload) {
        context.commit(SET_TICKET_LOADING, true);
        context.commit(SET_IS_DISABLED_TICKET, true);
        context.commit(CLEAR_TICKET_ERROR);
        
        return ApiService.put(`/ticket/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_TICKET_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı bilet başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_TICKET, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_TICKET_LOADING, false);
            context.commit(SET_TICKET_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_TICKET, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_TICKET](context, payload) {
        context.commit(SET_TICKET_LOADING, true);
        context.commit(CLEAR_TICKET_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/ticket/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_TICKET_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı bilet başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_TICKET_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    [GET_TICKETS_REPORT](context, payload) {
        context.commit(SET_IS_DISABLED_TICKET, true);
        context.commit(SET_TICKET_LOADING, true);
        context.commit(CLEAR_TICKET_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/get_tickets_report?matchid=${payload.match_id}&x=1`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_TICKET_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_TICKET_DATA, response.data);
                    context.commit(SET_TICKET_LOADING, false);
                    context.commit(SET_IS_DISABLED_TICKET, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_TICKET_LOADING, false);
                context.commit(SET_TICKET_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_TICKET, true);
            });
        });
    },

    [APPROVE_TICKET](context, payload) {
        context.commit(SET_TICKET_LOADING, true);
        context.commit(SET_IS_DISABLED_TICKET, true);
        context.commit(CLEAR_TICKET_ERROR);
        
        return ApiService.put(`/ticket/approve/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_TICKET_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    "Biletiniz başarıyla onaylanmıştır."
                );
            
                context.commit(SET_IS_DISABLED_TICKET, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_TICKET_LOADING, false);
            context.commit(SET_TICKET_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_TICKET, false);
            let errorMessages = Object.values(response.data.errors).flat().join(', ');
            AlertService.makeToast(
                "danger",
                "Hata!",
                errorMessages
            );
            
        });
        
    },

    
};

const mutations = {

    [SET_PAGINATED_TICKETS](state, paginatedTickets) {
        state.paginatedTickets = paginatedTickets.data;
    },

    [SET_PAGINATED_MY_TICKETS](state, paginatedMyTickets) {
        state.paginatedMyTickets = paginatedMyTickets.data;
    },

    [SET_ALL_TICKETS](state, tickets) {
        state.tickets = tickets;
    },

    [SET_TICKET_DATA](state, tickets_data) {
        state.tickets_data = tickets_data;
        state.errors = [];
    },

    [SET_TICKET_META](state, meta_ticket) {
        state.meta_ticket = meta_ticket;
    },

    [SET_TICKET_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_TICKET_ERROR](state) {
        state.errors = [];
    },
    
    [SET_TICKET_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_TICKET](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
